import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, Button } from '@mui/material';
import { Modal } from 'react-bootstrap';
import Editstudent from '../components/EditStudent';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from "xlsx";
import { buttonBackgroundColor } from '../common';

const StudentTable = () => {
    const [students, setStudents] = useState([]);
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [remark, setRemark] = useState('');


    const fetchStudents = () => {
        axios.get('registrationadvances/pendingStudentDetails')
            .then(response => {
                setStudents(response.data);
                setFilteredStudents(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    };

    useEffect(() => {
        fetchStudents(); // Fetch students on component mount
    }, []);

    useEffect(() => {
        setFilteredStudents(
            students.filter(student =>
                student.name.toLowerCase().includes(search.toLowerCase()) ||
                student.email.toLowerCase().includes(search.toLowerCase()) ||
                student.nric.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, students]);

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };

    const handleEditClick = (student) => {
        setSelectedStudent(student);
        setIsModalOpen(true);
    };

    const handleActivateClick = (student) => {
        console.log(student)
        setSelectedStudent(student);
        setIsConfirmModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedStudent(null);
    };

    const closeConfirmModal = () => {
        setIsConfirmModalOpen(false);
        setRemark('');
        setSelectedStudent(null);
    };

    const handleActivateStudent = () => {
        // console.log(selectedStudent)
        if (selectedStudent) {
            const data = {
                registrationId: selectedStudent.registrationAdvanceId,
                status: 'active',
            };
            if (remark === null || remark.trim() === '') {
                toast.error('Remarks cannot be empty.');
                return; // Exit the function if remarks are empty or null
            }
            if (remark) {
                data.remarks = remark;
            }
            axios.put('registrationadvances/update-status', data)
                .then(response => {

                    fetchStudents(); // Fetch the updated student list
                    closeConfirmModal();
                })
                .catch(error => {
                    console.error('Error updating student status:', error);
                });
        }
    };
    const exportToExcel = (data, fileName) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    const maskNRIC_FIN = (value) => {
        if (!value) return "";
        return value.slice(0, -4).replace(/\w/g, "*") + value.slice(-4);
    };
    return (
        <Paper>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                <TextField
                    label="Search by Name or NRIC"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    onChange={(e) => setSearch(e.target.value)}
                />

                <Button
                    variant="contained"
              
                    style={{  backgroundColor: buttonBackgroundColor }}
                    onClick={() =>
                        exportToExcel(
                            filteredStudents.map((student, index) => ({
                                "S.No": index + 1,
                                Name: student.name.toUpperCase(),
                                "Full Name": student.fullname.toUpperCase(),
                                NRIC: student.nric,
                                Email: student.email,
                                Phone: student.phone,
                                Gender: student.gender,
                                DOB: student.dob,
                            })),
                            "Full_Students_Data"
                        )
                    }
                >
                    Download Excel
                </Button>
            </div>
            <br />

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: "bold" }}>S No.</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>Full Name</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>NRIC</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>Email</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>Phone</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>Gender</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>DOB</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filteredStudents.length > 0 ? (
                            filteredStudents.map((student, index) => (
                                <TableRow key={student.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{student.name.toUpperCase()}</TableCell>
                                    <TableCell>{student.fullname.toUpperCase()}</TableCell>
                                    <TableCell>{student.nric}</TableCell>
                                    <TableCell>{student.email}</TableCell>
                                    <TableCell>{student.phone}</TableCell>
                                    <TableCell>{student.gender}</TableCell>
                                    <TableCell>{student.dob}</TableCell>
                                    <TableCell style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                        <Button variant="contained" color="success" onClick={() => handleEditClick(student)}>
                                            Edit
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="error"
                                            style={{ marginLeft: '10px' }}
                                            onClick={() => handleActivateClick(student)}
                                        >
                                            Activate
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={9} align="center" style={{ fontStyle: 'italic', color: '#999' }}>
                                    No data available
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={filteredStudents.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}

            <Modal show={isModalOpen} onHide={closeModal} fullscreen={true}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Student</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedStudent && <Editstudent from={true} pend={true} studentId={selectedStudent.registrationAdvanceId} />}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}   style={{
                                  backgroundColor: buttonBackgroundColor,
                                  color: 'white',
                                }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={isConfirmModalOpen} onHide={closeConfirmModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Activate Student</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to activate this student?</p>

                    <span style={{ color: 'red' }}>*</span>

                    <TextField
                        label="Remark"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={closeConfirmModal} style={{ marginRight: '10px' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleActivateStudent}>
                        OK
                    </Button>
                </Modal.Footer>

            </Modal>
        </Paper>
    );
};

export default StudentTable;
